import { SVG, SVGProps } from './svg'

export function IconLayout3h1v(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 16 16">
      <path d="M0 4c0-.6.4-1 1-1h2c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1H1a1 1 0 01-1-1V4zM6 4c0-.6.4-1 1-1h2c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1H7a1 1 0 01-1-1V4zM12 4c0-.6.4-1 1-1h2c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1h-2a1 1 0 01-1-1V4z" />
    </SVG>
  )
}
